"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestNoTypeExportWithouthConst = exports.UNCONFIGURED_DOMAIN = exports.UNCLASSIFIED_DOMAIN = exports.GoogleChannels = exports.DiscoverySetting = void 0;
var DiscoverySetting;
(function (DiscoverySetting) {
    DiscoverySetting["ON"] = "on";
    DiscoverySetting["OFF"] = "off";
})(DiscoverySetting || (exports.DiscoverySetting = DiscoverySetting = {}));
var GoogleChannels;
(function (GoogleChannels) {
    GoogleChannels["quarterly"] = "quarterly";
    GoogleChannels["beta"] = "beta";
})(GoogleChannels || (exports.GoogleChannels = GoogleChannels = {}));
/** for types that are not classified by the {@link DomainMap} in the config */
exports.UNCLASSIFIED_DOMAIN = 'Unclassified';
/** for types that are classified, but the specific instance is not properly configured with the `domain` attribute */
exports.UNCONFIGURED_DOMAIN = 'Unconfigured';
exports.TestNoTypeExportWithouthConst = '451';
